import { createFileRoute } from '@tanstack/react-router'

import { LegalAssistancePageSkeleton } from '#/modules/legal-assistance/front-office/legal-assistance-page/legal-assistance-page-skeleton.tsx'
import { LegalAssistancePage } from '#/modules/legal-assistance/front-office/legal-assistance-page/legal-assistance-page.tsx'
import { frontOfficeQueryOptions } from '#/shared/front-office-query-options.ts'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/(customer)/_shell/legal-assistance/')({
  beforeLoad: (options) => requirePermissions(options, ['contract.read']),
  loader: ({ context }) => {
    const { queryClient, trpc } = context
    return queryClient.ensureQueryData(
      trpc.legalAssistance.getClientLegalAssistanceAccess.queryOptions(undefined, frontOfficeQueryOptions),
    )
  },
  pendingComponent: LegalAssistancePageSkeleton,
  pendingMs: 150,
  component: LegalAssistancePage,
})
